// Some commments here
// donation it an object and donation.id & donation.title from danations data

const advertisements = [
  {
    id: "1",
    donation: {
      donationId: "1",
      donationTitle: "Masjid Donation",
    },
    poster:
      "https://i.ibb.co/Nj02ddV/Whats-App-Image-2023-06-18-at-10-17-28.jpg",
    isContact: false,
  },
  {
    id: "2",
    donation: {
      donationId: "3",
      donationTitle: "Zakat Al Maal",
    },
    poster:
      "https://i.ibb.co/z4BzJng/Whats-App-Image-2023-06-18-at-10-17-59.jpg",
    isContact: false,
  },
  {
    id: "3",
    donation: {
      donationId: "6",
      donationTitle: "Madrasha Donation",
    },
    poster:
      "https://i.ibb.co/wSkLZNh/Whats-App-Image-2023-06-18-at-10-16-29.jpg",
    isContact: false,
  },
    {
    id: "4",
    donation: {
      donationId: "7",
      donationTitle: "Food Fund",
    },
    poster:
      "https://i.ibb.co.com/ksDpxmFt/sadaqa-e-jariya.jpg",
  },
  {
    id: "6",
    poster:
      "https://i.ibb.co/5ck3bKD/Whats-App-Image-2024-05-17-at-03-04-57-1.jpg",
    isContact: true,
  },
  {
    id: "7",
    poster:
      "https://i.ibb.co/3CWjmMs/Whats-App-Image-2024-05-17-at-03-04-57.jpg",
    isContact: false,
  },
  {
    id: "8",
    poster:
      "https://i.ibb.co/mX2Nkb6/Whats-App-Image-2024-05-17-at-03-08-22.jpg",
    isContact: false,
  },
  {
    id: "9",
    poster:
      "https://i.ibb.co.com/5g1Mpfq1/Whats-App-Image-2025-02-03-at-08-22-11.jpg",
    isContact: false,
  },

  // {
  //   id: "4",
  //   donation: {
  //     donationId: "2",
  //     donationTitle: "Zakat Al Fitr",
  //   },
  //   poster: "https://i.ibb.co/CWZFnX3/zakat-al-fitr.jpg",
  // },
  // {
  //   id: "5",
  //   donation: {
  //     donationId: "4",
  //     donationTitle: "Massey Iftar Donation",
  //   },
  //   poster:
  //     "https://i.ibb.co/d5HXKK2/Whats-App-Image-2023-03-27-at-09-19-49.jpg",
  // },
  // {
  //   id: "6",
  //   poster:
  //     "https://i.ibb.co/RpLW4pQ/Whats-App-Image-2023-04-20-at-10-26-21.jpg",
  // },
  // {
  //   id: "7",
  //   poster:
  //     "https://i.ibb.co/L1LZqhc/Whats-App-Image-2023-03-23-at-09-49-31.jpg",
  //   isContact: true,
  // },
  // {
  //   id: "8",
  //   donation: {
  //     donationId: "5",
  //     donationTitle: "Our Masjid Iftar Program",
  //   },
  //   poster:
  //     "https://i.ibb.co/k1rs7n6/Whats-App-Image-2023-03-27-at-10-29-06.jpg",
  // },

  {
    id: "10",
    donation: {
      donationId: "9",
      donationTitle: "Dawah",
    },
    poster:
      "https://i.ibb.co/6Rdm77y/Whats-App-Image-2023-06-18-at-10-15-26.jpg",
  },
];

export default advertisements;
